import { resourceScopeTag } from '@krp/client-runtime'

import { onecEnvelopeDecoder, type OneCEnvelope } from '../../../shared/api/onecEnvelope'
import { normalizeRid } from '../../../shared/model/scopeKeys'
import { receiptsApi, receiptsTag } from '../../receipts/api/receiptsApi'
import { KEEP_PAST_SECONDS } from '../../receipts/model/constants'
import type { CashShifts, CashShiftsArgs } from '../model/types'
import { decodeCashShifts } from './contracts'
import { ONEC_SHIFTS_URLS } from './urls'

/**
 * Кассовые смены базы 1С (раздел «Смены») в ОБЩЕМ `baseApi` (через `receiptsApi`, где объявлен тег чеков). Служба читает 1С на лету и ничего не хранит. Тег — тот же, что у
 * чеков и касс: «Обновить» и «Повторить» перечитывают кассы и смены одним действием.
 */
export const shiftsApi = receiptsApi.injectEndpoints({
  endpoints: (build) => ({
    onecCashShifts: build.query<OneCEnvelope<CashShifts>, CashShiftsArgs>({
      keepUnusedDataFor: KEEP_PAST_SECONDS,
      query: ({ resourceId, from, to }) => ({
        url: ONEC_SHIFTS_URLS.list(resourceId, from, to),
        // Чтение идёт в 1С: отказ показывается сразу, следующий запрос — «Повторить» человека.
        noRetry: true,
        decode: onecEnvelopeDecoder(resourceId, decodeCashShifts(resourceId)),
      }),
      providesTags: (_result, _error, { resourceId }) => [receiptsTag(resourceId), resourceScopeTag(normalizeRid(resourceId))],
    }),
  }),
})

export const { onecCashShifts } = shiftsApi.endpoints
